import React from 'react';

// Iconos de macronutrientes (alineados con las claves de theme.js)
import caloriesIcon from './calories.png';
import proteinIcon from './protein.png';
import carbsIcon from './carbs.png';
import fatIcon from './fat.png';

// Iconos de navegación / secciones
import dashboardIcon from './dashboard.png';
import recetasIcon from './recetas.png';
import planSemanalIcon from './plan-semanal.png';
import listsIcon from './lists.png';
import userIcon from './user.png';

/**
 * Mapa de iconos de macronutrientes. Las claves coinciden con las usadas en
 * theme.js (macroNames, macroShortNames, macroInitials, macroUnits) para poder
 * resolver el icono a partir del mismo identificador de macro.
 */
export const macroIcons = {
  kilocalories: caloriesIcon,
  protein: proteinIcon,
  carbs: carbsIcon,
  fat: fatIcon,
};

/**
 * Mapa de iconos de las secciones principales de la app.
 */
export const sectionIcons = {
  dashboard: dashboardIcon,
  recetas: recetasIcon,
  planSemanal: planSemanalIcon,
  lists: listsIcon,
  user: userIcon,
};

export {
  caloriesIcon,
  proteinIcon,
  carbsIcon,
  fatIcon,
  dashboardIcon,
  recetasIcon,
  planSemanalIcon,
  listsIcon,
  userIcon,
};

/**
 * Icono de macronutriente reutilizable.
 * @param {('kilocalories'|'protein'|'carbs'|'fat')} macro - clave del macro
 * @param {number} size - tamaño en px (cuadrado)
 */
export const MacroIcon = ({ macro, size = 20, style, ...props }) => {
  const src = macroIcons[macro];
  if (!src) return null;
  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      style={{ objectFit: 'contain', display: 'block', flexShrink: 0, ...style }}
      {...props}
    />
  );
};

/**
 * Icono de sección reutilizable (dashboard, recetas, planSemanal).
 * @param {('dashboard'|'recetas'|'planSemanal')} section - clave de la sección
 * @param {number} size - tamaño en px (cuadrado)
 */
export const SectionIcon = ({ section, size = 24, style, ...props }) => {
  const src = sectionIcons[section];
  if (!src) return null;
  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      style={{ objectFit: 'contain', display: 'block', flexShrink: 0, ...style }}
      {...props}
    />
  );
};
